import { Reveal } from "@/components/Reveal";
import { HOME } from "@/constants/testIds";
import {
    APPLE_URL,
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
    SOUNDCLOUD_URL,
    SPOTIFY_URL,
} from "@/lib/constants";

const channels = [
    { label: "spotify", href: SPOTIFY_URL, testId: HOME.followSpotifyCta, note: "the playlist" },
    { label: "apple music", href: APPLE_URL, testId: HOME.followAppleCta, note: "the mirror" },
    { label: "soundcloud", href: SOUNDCLOUD_URL, testId: HOME.followSoundcloudCta, note: "the mirror" },
];

export const Follow = () => (
    <section id="follow" data-testid={HOME.follow} aria-label="stay close to it — follow deep end grooves" className="border-b border-[var(--rule)]">
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16 py-20 sm:py-24 lg:py-28">
            <div className="grid gap-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-end">
                <Reveal>
                    <p className="eyebrow text-[var(--terracotta-ink)]">05 — follow</p>
                    <h2 className="font-display mt-6 text-4xl sm:text-5xl max-w-[14ch]">stay close to it — follow deep end grooves</h2>
                    <p className="prose-body mt-8 max-w-[38ch] text-base">
                        weekly additions, sleeve notes and the occasional record shot. no reels, no dance edits of
                        someone else&apos;s song.
                    </p>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={HOME.instagramCta}
                        className="mt-9 inline-block border border-[var(--ink)] bg-[var(--ink)] px-8 py-4 text-base font-bold uppercase tracking-[0.08em] text-[var(--cream)] hover:bg-[var(--terracotta-ink)] hover:border-[var(--terracotta-ink)] transition-colors duration-200"
                    >
                        {INSTAGRAM_HANDLE} on instagram
                    </a>
                </Reveal>

                <Reveal delay={0.05}>
                    <ul className="border-t border-[var(--rule)]">
                        {channels.map((c) => (
                            <li key={c.label} className="border-b border-[var(--rule)]">
                                <a
                                    href={c.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={c.testId}
                                    className="flex items-baseline justify-between gap-6 py-6 hover:text-[var(--terracotta-ink)] transition-colors duration-200"
                                >
                                    <span className="font-display text-2xl sm:text-3xl">{c.label}</span>
                                    <span className="eyebrow opacity-80">{c.note}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </div>
    </section>
);
